module.exports = __webpack_public_path__ + "img/logo_KAI-Pay.8e65736e.png";